import Card from 'components/Card/Card.jsx';
import moment from 'moment';
import queryString from 'query-string';
import React, { Component } from 'react';
import { Button, Col, Grid, Row, Badge } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import Form from 'react-jsonschema-form';
import { connect } from 'react-redux';
//Redux
import { bindActionCreators } from 'redux';
//import Activities from '../../components/Activities/Activities';
import Comments from '../../components/Comments/Comments';
//import widgetsReaction from '../../components/Widgets/widget-reaction';
import widgets from '../../lib/widgets';
import auth from '../../libCustom/auth';
import * as ClientsActions from './redux/ClientsActions';

const paramsUsers = {
  fields: {
    emailConfiguration: false,
    roles: false,
    firstName: true,
    lastName: true,
    id: true,
  },
  where: {
    franchiseId: '',
  },
};

const schema = {
  $id: 'http://example.com/example.json',
  type: 'object',
  definitions: {},
  $schema: 'http://json-schema.org/draft-07/schema#',
  required: ['assignedTo', 'saludation', 'firstName', 'lastName', 'phone'],
  properties: {
    assignedTo: {
      $id: '/properties/userId',
      type: 'string',
      title: 'Asigando a',
      api:
        process.env.REACT_APP_URL_API +
        '/api/users?filter=' +
        JSON.stringify(paramsUsers),
      options: {
        value: 'id',
        label: 'firstName',
      },
      default: '',
      examples: [''],
    },
    saludation: {
      $id: '/properties/saludation',
      type: 'integer',
      title: 'Saludo',
      default: 1,
      examples: [1],
      enum: [
        ' ',
        'Sr.',
        'Sra.',
        'Srta.',
        'Dr.',
        'Lic.',
        'Arq.',
        'Ing.',
        'Mtro.',
        'Joven',
      ],
      enumNames: [
        '-- Seleccionar',
        'Sr.',
        'Sra.',
        'Srta.',
        'Dr.',
        'Lic.',
        'Arq.',
        'Ing.',
        'Mtro.',
        'Joven',
      ],
    },
    from: {
      $id: '/properties/from',
      type: 'string',
      title: 'Medio de contacto',
      enum: [' ', 'Redes sociales', 'Recomendación', 'Publicidad', 'others'],
      enumNames: [
        '-- Seleccionar',
        'Redes sociales',
        'Recomendación',
        'Publicidad',
        'Otros',
      ],
    },
    otherContact: {
      $id: '/properties/otherContact',
      type: 'string',
      title: 'Especificar otro medio',
      examples: ['Especificar aquí...'],
    },
    firstName: {
      $id: '/properties/firstName',
      type: 'string',
      title: 'Nombre(s)',
      default: '',
      examples: ['Mario'],
    },
    lastName: {
      $id: '/properties/lastName',
      type: 'string',
      title: 'Apellidos',
      default: '',
      examples: ['Mario'],
    },
    phone: {
      $id: '/properties/phone',
      type: 'string',
      title: 'Teléfono',
      default: '',
      examples: ['3 12 34 34'],
    },
    email: {
      $id: '/properties/email',
      type: 'string',
      title: 'Email 1',
      default: '',
      examples: ['mario@gmail.com'],
    },
    email2: {
      $id: '/properties/email2',
      type: 'string',
      title: 'Email 2',
      default: '',
      examples: ['mario@gmail.com'],
    },
    notes: {
      $id: '/properties/notes',
      type: 'string',
      title: 'Notas de datos generales',
      default: '',
      examples: ['example notes'],
    },
    birthday: {
      $id: '/properties/birthday',
      type: 'string',
      title: 'Fecha de nacimiento',
      default: '',
      examples: ['Wed May 16 2018 19:25:16 GMT-0500 (CDT)'],
    },
    /*franchiseId: {
      $id: "/properties/franchiseId",
      type: "integer",
      title: "Franquicia",
      default: 1,
      examples: [1],
      enum: [0, 1, 2, 3, 4],
      enumNames: [
        "-- Seleccionar",
        "Matriz",
        "Centro",
        "Santiaguito",
        "Chapultepec"
      ]
    },*/
    address: {
      $id: '/properties/address',
      type: 'string',
      title: 'Dirección',
      default: '',
      examples: ['example notes'],
    },
    billingInformation: {
      $id: '/properties/billingInformation',
      type: 'object',
      title: 'Información Fiscal',
      properties: {
        name: {
          $id: '/properties/billingInformation/properties/name',
          type: 'string',
          title: 'Nombre o razón social',
          default: '',
          examples: ['Mario'],
        },
        rfc: {
          $id: '/properties/billingInformation/properties/rfc',
          type: 'string',
          title: 'RFC',
          default: '',
          examples: ['MELM8305281H0'],
        },
        email: {
          $id: '/properties/billingInformation/properties/email',
          type: 'string',
          title: 'Email',
          default: '',
          examples: ['mail@gmail.com'],
        },
        address: {
          $id: '/properties/billingInformation/properties/address',
          type: 'object',
          title: 'Dirección Fiscal',
          properties: {
            street: {
              $id: '/properties/billingInformation/properties/address/properties/street',
              type: 'string',
              title: 'Calle',
              default: '',
              examples: ['Miguel Hidalgo'],
            },
            extNumber: {
              $id: '/properties/billingInformation/properties/address/properties/extNumber',
              type: 'string',
              title: 'No. Ext',
              default: '',
              examples: ['56'],
            },
            intNumber: {
              $id: '/properties/billingInformation/properties/address/properties/intNumber',
              type: 'string',
              title: 'No. Interior',
              default: '',
              examples: ['b'],
            },
            suburb: {
              $id: '/properties/billingInformation/properties/address/properties/suburb',
              type: 'string',
              title: 'Colonia',
              default: '',
              examples: ['Niños Héroes'],
            },
            zipcode: {
              $id: '/properties/billingInformation/properties/address/properties/zipcode',
              type: 'integer',
              title: 'Código Postal',
              default: 0,
              examples: [58260],
            },
            locality: {
              $id: '/properties/billingInformation/properties/address/properties/locality',
              type: 'string',
              title: 'Localidad',
              default: '',
              examples: ['b'],
            },
            city: {
              $id: '/properties/billingInformation/properties/address/properties/city',
              type: 'string',
              title: 'Ciudad',
              default: '',
              examples: ['a'],
            },
            state: {
              $id: '/properties/billingInformation/properties/address/properties/state',
              type: 'string',
              title: 'Estado',
              default: '',
              examples: ['c'],
            },
          },
        },
      },
    },
    contacts: {
      $id: '/properties/contacts',
      type: 'array',
      title: 'Contacto de emergencia del cliente',
      items: {
        $id: '/properties/contacts/items',
        type: 'object',
        properties: {
          nameContact: {
            $id: '/properties/contacts/items/properties/nameContact',
            type: 'string',
            title: 'Nombre',
            default: '',
            examples: ['N'],
          },
          lastNameContact: {
            $id: '/properties/contacts/items/properties/lastNameContact',
            type: 'string',
            title: 'Apellidos',
            default: '',
            examples: ['description'],
          },
          phoneContact: {
            $id: '/properties/contacts/items/properties/phoneContact',
            type: 'string',
            title: 'Teléfono',
            default: '',
            examples: ['234323'],
          },
          relation: {
            $id: '/properties/relation',
            type: 'string',
            title: 'Parentesco',
          },
          observations: {
            $id: '/properties/contacts/items/properties/observations',
            type: 'string',
            title: 'Observaciones',
            default: '',
            examples: ['234323'],
          },
        },
      },
    },
  },
};

const schemaMessages = {
  $id: '/properties/messages',
  type: 'array',
  items: {
    $id: '/properties/messages/items',
    type: 'object',
    properties: {
      userId: {
        $id: '/properties/messages/items/properties/userId',
        type: 'number',
        title: 'Vendedor',
        enum: [0, 1, 2, 3],
        enumNames: [
          '-- Seleccionar',
          'María Luisa',
          'Eric Gómez Estrada',
          'Mariana Figueroa Quintana',
        ],
      },
      datetime: {
        $id: '/properties/messages/items/properties/datetime',
        type: 'string',
        title: 'Fecha y hora',
        default: '',
        examples: ['description'],
      },
      body: {
        $id: '/properties/messages/items/properties/body',
        type: 'string',
        title: 'Mensaje',
        default: '',
        examples: ['234323'],
      },
    },
  },
};

const schemaTodo = {
  $id: '/properties/todo',
  type: 'array',
  items: {
    $id: '/properties/todo/items',
    type: 'object',
    properties: {
      userId: {
        $id: '/properties/todo/items/properties/userId',
        type: 'number',
        title: 'Vendedor',
        enum: [0, 1, 2, 3],
        enumNames: [
          '-- Seleccionar',
          'María Luisa',
          'Eric Gómez Estrada',
          'Mariana Figueroa Quintana',
        ],
      },
      date: {
        $id: '/properties/todo/items/properties/date',
        type: 'string',
        title: 'Fecha',
        default: '',
        examples: ['description'],
      },
      activity: {
        $id: '/properties/todo/items/properties/activity',
        type: 'string',
        title: 'Actividad',
        default: '',
        examples: ['description'],
      },
      completed: {
        $id: '/properties/todo/items/properties/completed',
        type: 'boolean',
        title: 'Realizada?',
        default: false,
        examples: ['234323'],
      },
    },
  },
};

const uiSchema = {
  /* reaction: {
    'ui:widget': widgetsReaction
  }, */
  email: {
    'ui:widget': 'email',
  },
  notes: {
    'ui:widget': 'textarea',
  },
  otherContact: {},
  address: {
    'ui:widget': 'textarea',
  },
  observations: {
    'ui:widget': 'textarea',
  },
  birthday: {
    'ui:widget': 'date',
  },
  franchiseId: {
    'ui:disabled': true,
  },
  assignedTo: {
    'ui:widget': 'SelectRemoteWidget',
  },
  contacts: {
    items: {
      observations: {
        'ui:widget': 'textarea',
      },
    },
  },

  createdOn: {
    'ui:disabled': true,
  },
};

const uiSchemaMessages = {
  items: {
    userId: {
      'ui:disabled': true,
    },
    datetime: {
      'ui:disabled': true,
      'ui:widget': 'datetime',
    },
    body: {
      'ui:widget': 'textarea',
    },
  },
};

const uiSchemaTodo = {
  items: {
    date: {
      'ui:widget': 'date',
    },
  },
};

const log = (type) => console.log.bind(console, type);

class ClientsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      openConfirm: false,
      openSuccess: false,
      schema: schema,
      schemaMessages: schemaMessages,
      schemaTodo: schemaTodo,
      formData: {},
      uiSchema: uiSchema,
      formDataMessages: [],
      formDataSend: {},
      disabled: true,
    };
  }

  componentWillMount() {
    var querys = queryString.parse(this.props.location.search);

    this.state.uiSchema.otherContact['ui:widget'] = 'hidden';
    if (this.state.id !== 'create') {
      //TODO Toño  - Agregar los parametros de busqueda que se ocupan para si "props.match.params.historyDate no es undefined traiga los de esa fecha.
      this.props.findById(this.state.id);
    }
  }
  componentWillUnmount() {
    if (!auth.verifyLogin()) return false;
    this.props.stateInit();
    uiSchema.firstName =
      uiSchema.firstName !== undefined ? uiSchema.firstName : {};
    uiSchema.firstName['ui:disabled'] = false;
    uiSchema.lastName =
      uiSchema.lastName !== undefined ? uiSchema.lastName : {};
    uiSchema.lastName['ui:disabled'] = false;

    uiSchema.phone = uiSchema.phone !== undefined ? uiSchema.phone : {};
    uiSchema.phone['ui:disabled'] = false;
    uiSchema.email = uiSchema.email !== undefined ? uiSchema.email : {};
    uiSchema.email['ui:disabled'] = false;
    uiSchema.email2 = uiSchema.email2 !== undefined ? uiSchema.email2 : {};
    uiSchema.email2['ui:disabled'] = false;
    uiSchema.notes = uiSchema.notes !== undefined ? uiSchema.notes : {};
    uiSchema.notes['ui:disabled'] = false;
    uiSchema.birthday =
      uiSchema.birthday !== undefined ? uiSchema.birthday : {};
    uiSchema.birthday['ui:disabled'] = false;
    uiSchema.address = uiSchema.address !== undefined ? uiSchema.address : {};
    uiSchema.address['ui:disabled'] = false;
    uiSchema.billingInformation =
      uiSchema.billingInformation !== undefined
        ? uiSchema.billingInformation
        : {};
    uiSchema.billingInformation['ui:disabled'] = false;
    uiSchema.contacts !== undefined ? uiSchema.contacts : {};
    uiSchema.contacts['ui:disabled'] = false;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      id: nextProps.match.params.id,
      formData: nextProps.Clients.formData,
      formDataMessages:
        nextProps.Clients.formData.messages !== undefined
          ? nextProps.Clients.formData.messages
          : [],
      formDataTodo: nextProps.Clients.formData.todo,
      formDataSend: nextProps.Clients.formData,
    });
  }

  onSubmit = ({ formData }) => {
    let _this = this;
    const { firstName, lastName } = this.state.formDataSend;

    const firstNameUpper = firstName.toUpperCase();
    const lastNameUpper = lastName.toUpperCase();

    this.state.formDataSend.fullText =
      firstNameUpper +
      ' ' +
      lastNameUpper +
      ' ' +
      this.state.formDataSend.phone +
      ' ' +
      this.state.formDataSend.email;

    this.state.formDataSend.firstName = firstNameUpper;
    this.state.formDataSend.lastName = lastNameUpper;

    if (this.state.id !== 'create') {
      //TODO Toño - Crear un historial de lo que se va guardando, con el plugin que hace el softdelete.
      this.props
        .update(this.state.formDataSend.id, this.state.formDataSend)
        .then(function () {
          _this.props.history.push('/admin/clients');
        });
    } else {
      this.props.create(this.state.formDataSend).then(function () {
        _this.props.history.push('/admin/clients');
      });
    }
  };

  onDelete(confirm = false) {
    let _this = this;
    if (confirm) {
      this.props.update(this.state.id, { deleted: true }).then(function () {
        _this.props.history.push('/admin/clients');
      });
    } else {
      this.setState({ openConfirm: true });
    }
  }

  onChange = (value) => {
    const updatedUiSchema = { ...uiSchema };
    updatedUiSchema.otherContact['ui:widget'] =
      value &&
        value.formData &&
        value.formData.from &&
        value.formData.from === 'others'
        ? 'text'
        : 'hidden';

    this.setState({
      uiSchema: updatedUiSchema,
      formData: value.formData,
      formDataSend: value.formData,
    });
  };

  onComment = (comment) => {
    var newFormDataMessages = [
      ...this.state.formDataMessages,
      {
        body: comment,
      },
    ];
    this.setState({
      formDataSend: {
        ...this.state.formDataSend,
        messages: newFormDataMessages,
      },
      formDataMessages: newFormDataMessages,
    });
  };

  onChangeMessages = (value) => {
    this.setState({
      formDataSend: { ...this.state.formDataSend, messages: value.formData },
      formDataMessages: value.formData,
    });
  };

  onChangeTodo = (value) => {
    this.setState({
      formDataSend: { ...this.state.formDataSend, todo: value.formData },
      formDataTodo: value.formData,
    });
  };

  render() {
    if (auth.can('sales') && this.state.id !== 'create') {
      uiSchema.firstName =
        uiSchema.firstName !== undefined ? uiSchema.firstName : {};
      uiSchema.firstName['ui:disabled'] = true;
      uiSchema.lastName =
        uiSchema.lastName !== undefined ? uiSchema.lastName : {};
      uiSchema.lastName['ui:disabled'] = true;

      uiSchema.phone = uiSchema.phone !== undefined ? uiSchema.phone : {};
      uiSchema.phone['ui:disabled'] = true;
      uiSchema.email = uiSchema.email !== undefined ? uiSchema.email : {};
      uiSchema.email['ui:disabled'] = true;
      uiSchema.email2 = uiSchema.email2 !== undefined ? uiSchema.email2 : {};
      uiSchema.email2['ui:disabled'] = true;
      uiSchema.notes = uiSchema.notes !== undefined ? uiSchema.notes : {};
      uiSchema.notes['ui:disabled'] = true;
      uiSchema.birthday =
        uiSchema.birthday !== undefined ? uiSchema.birthday : {};
      uiSchema.birthday['ui:disabled'] = true;
      uiSchema.address = uiSchema.address !== undefined ? uiSchema.address : {};
      uiSchema.address['ui:disabled'] = true;
      uiSchema.billingInformation =
        uiSchema.billingInformation !== undefined
          ? uiSchema.billingInformation
          : {};
      uiSchema.billingInformation['ui:disabled'] = true;
      uiSchema.contacts !== undefined ? uiSchema.contacts : {};
      uiSchema.contacts['ui:disabled'] = true;
    }
    const franchiseId = auth.getCurrentUser().franchiseId;
    const paramsUsers = {
      fields: {
        emailConfiguration: false,
        roles: false,
        firstName: true,
        lastName: true,
        id: true,
      },
      where: {
        franchiseId: franchiseId,
        isDeleted: { neq: true },
      },
    };

    if (
      this.state &&
      this.state.formData &&
      this.state.formData.from &&
      this.state.formData.from === 'others'
    ) {
      uiSchema.otherContact['ui:widget'] = 'text';
    }

    this.state.schemaMessages.items.properties.datetime.default =
      moment().format();
    this.state.schemaMessages.items.properties.userId.default =
      auth.getCurrentUser().id;
    this.state.schemaTodo.items.properties.userId.default =
      auth.getCurrentUser().id;
    this.state.schema.properties.assignedTo.default =
      this.props.Clients.assignedTo !== undefined
        ? this.props.Clients.assignedTo
        : auth.getCurrentUser().id;

    this.state.schema.properties.assignedTo.api =
      process.env.REACT_APP_URL_API +
      '/api/users?filter=' +
      JSON.stringify(paramsUsers);

    let { history, Clients } = this.props;
    let { id, openConfirm, openSuccess } = this.state;
    const styles = {
      div: {
        marginBottom: '15px',
      },
      saveButton: {
        backgroundColor: '#447DF7',
        borderColor: '#447DF7',
        marginRight: '10px',
      },
      cancelButton: {
        borderColor: '#447DF7',
        color: '#447DF7',
        marginRight: '10px',
      },
    };

    return (
      <div className="main-content">
        {openConfirm && (
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Estás Seguro?"
            onConfirm={() => this.onDelete(true)}
            onCancel={() => this.setState({ openConfirm: false })}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si, borrar!"
            cancelBtnText="Cancelar"
            showCancel
          >
            No podrás deshacer está opción!
          </SweetAlert>
        )}

        {openSuccess && (
          <SweetAlert
            success
            style={{ display: 'block', marginTop: '-100px' }}
            title="Listo!"
            confirmBtnBsStyle="info"
            onConfirm={() => this.setState({ openSuccess: false })}
          >
            Se ha actualizado correctamente!
          </SweetAlert>
        )}

        <Grid fluid>
          <Row>
            <div className="pull-right" style={styles.div}>
              <Button
                style={styles.cancelButton}
                form="client"
                bsStyle="default"
                onClick={() => history.push('/admin/clients')}
              >
                Regresar
              </Button>
              <div className="pull-right">
                {!auth.can('sales') ? (
                  <Button
                    style={styles.saveButton}
                    form="client"
                    type="submit"
                    className="btn-fill"
                  >
                    Guardar
                  </Button>
                ) : null}
                {auth.can('sales') && this.state.id === 'create' ? (
                  <Button
                    style={styles.saveButton}
                    form="client"
                    type="submit"
                    className="btn-fill"
                  >
                    Guardar
                  </Button>
                ) : null}
              </div>
            </div>
          </Row>
          <Row>
            <Col md={7}>
              <Card
                title={<legend>Editar Cliente</legend>}
                content={
                  <div>
                    <Badge style={{ fontSize: '14px', background: '#3a82cc' }}>
                      Fecha de creación:{' '}
                      {moment(this.state.formDataSend.createdOn).format('ll')}
                    </Badge>

                    <br />
                    <br />
                    <Form
                      key={JSON.stringify(this.state.uiSchema)}
                      id="client"
                      schema={this.state.schema}
                      widgets={widgets}
                      uiSchema={this.state.uiSchema}
                      onSubmit={this.onSubmit}
                      onChange={this.onChange}
                      formData={this.state.formData}
                      onError={log('errors')}
                    >
                      <div />
                    </Form>

                    <div className="clearfix" />
                  </div>
                }
              />
            </Col>
            <Col md={5}>
              <Card
                title={
                  <legend>Observaciones (Gustos, preferencias, etc.)</legend>
                }
                content={
                  <div>
                    <Comments
                      comments={this.state.formDataMessages}
                      onComment={this.onComment}
                    />
                  </div>
                }
              />
              {/*<Card
                title={<legend>Recordatorios</legend>}
                content={
                  <div>
                    <Activities
                      onAdd={value => console.log('value', value)}
                      onNewActivity={() => {}}
                    />
                    
                  </div>
                }
              />
            */}
              {/* <Card title={<legend>Cotizaciones</legend>} content={<div />} />
              <Card title={<legend>Ventas</legend>} content={<div />} />*/}
            </Col>
            {/* //TODO Toño - Pasar la lista de historiales "this.sate.history" a Paty. */}
            {/* //TODO Paty - Crear una card en donde se muestre la lista de historiales por fecha y hora y como click para que se realice de nuevo una consulta con los datos del historia  - https://getbootstrap.com/docs/4.0/components/list-group/ */}
          </Row>
          <Row>
            <div className="pull-right">
              {!auth.can('sales') ? (
                <Button
                  bsStyle="danger"
                  form="client"
                  onClick={() => this.onDelete(false)}
                >
                  Borrar
                </Button>
              ) : null}
            </div>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Clients: state.Clients,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ClientsActions, dispatch);
};

const ClientsConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientsForm);

export default ClientsConnect;



// WEBPACK FOOTER //
// ./src/views/Clients/ClientsForm.jsx